export default __webpack_public_path__ + "static/media/contact_us_illustration.134aa952.png";